import { initFancyBox } from "@common/index";
import { countUp } from "../utils/utils";

const _ourService = () => {
  const pageMarker = $("._seo_");
  if (!pageMarker.length) return;
  $(function () {
    if (window.innerWidth === 1350 || window.innerWidth === 412) {
      $(document).one("mousemove", () => {
        initFunction();
      });
      $(document).one("scroll", () => {
        initFunction();
      });
    } else {
      initFunction();
    }
  });

  let initFunction = () => {

    initFunction = () => { };
    initFancyBox();
    initEvent();
    countUp(".counter");
  };

  function initEvent() {
    copyWorkflowsItem()
  }

  function copyWorkflowsItem() {
    const item = $('.workflows .workflows-list .list:nth-child(1) li:nth-child(2n)');
    $('.list-copy').append(item.clone());
  }

};

export default _ourService;
